<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">财务系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>实时生成钱包余额快照</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="margin-top: 20px">
            <el-autocomplete class="inline-input" style="width: 200px"
                             v-model="queryParams.coinType"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入币种">
                <i class="el-icon-close el-input__icon" slot="suffix"
                   @click="cleanSearchCoinOne" style="cursor:pointer;">
                </i>
            </el-autocomplete>
            <el-select v-model="queryParams.status" placeholder="请选择状态">
                <el-option v-for="item in statusArr" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
            </el-select>
            <el-button style="margin-left: 10px" type="primary" @click="searchData">搜 索</el-button>
            <el-button style="margin-left: 10px" icon="el-icon-plus" type="danger" @click="openCreateDialog">新 增
            </el-button>
        </div>

        <div style="margin-top: 20px">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="coinType" label="币种"></el-table-column>
                <el-table-column prop="walletUserAmount" label="用户钱包"></el-table-column>
                <el-table-column prop="walletWithAmount" label="提现钱包"></el-table-column>
                <el-table-column prop="walletColdAmount" label="冷钱包" show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletHedgeAmount" label="缓冲钱包" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remake" label="备注"></el-table-column>
                <el-table-column prop="executeInformation" label="执行信息"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span>{{scope.row.status | formatStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="新增" :visible.sync="dialogVisible" width="500px" @close="clearData">
            <el-form label-width="100px" :model="addData" :rules="addRules" ref="addForm">
                <el-form-item label="币种：" prop="coinType">
                    <el-autocomplete class="inline-input" style="width: 80%"
                                     v-model="addData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="addData.remake"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible=false">取 消</el-button>
                <el-button type="danger" @click="addRecord">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: "SnapshotManage",
        data() {
            return {
                dataList: [], //申购列表
                total: 0, //总条数
                queryParams: { //查询参数
                    coinType: "",
                    status: "",
                    page: 1,
                    size: 10
                },
                dialogVisible: false,
                addData: {
                    remake: "",
                    coinType: ""
                },
                addRules: {
                    "coinType": [{required: true, message: "币种不能为空"}]
                },
                coinTypes: [],
                statusArr: [
                    {value: "", label: "所有"},
                    {value: 0, label: "初始化,管理端创建-未执行状态"},
                    {value: 1, label: "执行中,正在获取代币余额"},
                    {value: 2, label: "执行成功,获取余额完成"},
                    {value: 3, label: "执行失败,获取余额失败"}
                ]
            };
        },
        filters: {
            formatStatus(val) {
                let str = "";
                switch (val) {
                    case 0:
                        str = "初始化,管理端创建-未执行状态";
                        break;
                    case 1:
                        str = "执行中,正在获取代币余额";
                        break;
                    case 2:
                        str = "执行成功,获取余额完成";
                        break;
                    case 3:
                        str = "执行失败,获取余额失败";
                        break;
                }
                return str;
            }
        },
        methods: {
            searchData() {
                this.queryParams.page = 1;
                this.queryWalletReconciliationList(this.queryParams);
            },
            openCreateDialog() {
                this.dialogVisible = true;
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            queryWalletReconciliationList(query) {
                api.queryWalletReconciliationList(query).then(({data}) => {
                    this.dataList = data.list;
                    this.total = data.totalCount;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.queryWalletReconciliationList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.queryWalletReconciliationList(this.queryParams);
            },
            addRecord() {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        api.createWalletReconciliation(this.addData).then(({data}) => {
                            this.$message.success('新增成功！');
                            this.dialogVisible = false;
                            this.queryParams.page = 1;
                            this.queryWalletReconciliationList(this.queryParams);
                        });
                    }
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addData.coinType = '';
            },
            cleanSearchCoinOne() {
                this.queryParams.coinType = '';
            },
            clearData() {
                this.addData = {remake: "", coinType: ""}
            },
        },
        created() {
            this.queryWalletReconciliationList(this.queryParams);
            this.getAllSupportCoin();
        }
    }
</script>

<style scoped>

</style>